import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './HtmlContent.module.less';

const HtmlContent = ({ ecmContent }) => {
  const { content = '', contentJson = {} } = ecmContent || {};

  const wrapper = classNames(styles.html_content, {
    [styles.container]: contentJson?.classNameStyle === 'container',
    [styles.indented_container]: contentJson?.classNameStyle !== 'container'
  });

  return <div className={wrapper} dangerouslySetInnerHTML={{ __html: content }} />;
};

HtmlContent.propTypes = {
  ecmContent: PropTypes.object.isRequired
};

export default HtmlContent;
